import { makeStyles } from "tss-react/mui"
import { Stack, TextField } from "@mui/material"
import { StandardDialog } from "../../../../../../../../shared/components/dialogs/StandardDialog"
import { LocalizedStrict } from "../../../../../../../localization/components/AppLocalized"
import { StandardButton } from "../../../../../../../../shared/components/buttons/StandardButton"
import React, { useState } from "react"
import { DateTimePicker, renderTimeViewClock } from "@mui/x-date-pickers"
import { DateTime } from "luxon"

const useStyles = makeStyles()((theme) => ({
    container: {
        padding: "2rem 4rem",
    },
}))

type AddClosingTimeDialogProps = Readonly<{
    onAdd: ({ start, end, reason }: { start?: DateTime; end?: DateTime; reason: string }) => void
    open: boolean
    onClose: () => void
}>

export function AddClosingTimeDialog({ open, onClose, onAdd }: AddClosingTimeDialogProps) {
    const { classes } = useStyles()
    const [newItem, setNewItem] = useState<{
        start: DateTime
        end: DateTime
        reason: string
    }>({
        start: DateTime.now().minus({ days: 1 }),
        end: DateTime.now(),
        reason: "",
    })
    return (
        <StandardDialog
            dialogTitle={
                <LocalizedStrict id="tab-availability-modal-title">
                    <>Add closed period</>
                </LocalizedStrict>
            }
            open={open}
            onClose={onClose}
            maxWidthProp="sm"
            scroll="body"
        >
            <Stack className={classes.container} spacing="2rem">
                <Stack direction="row" spacing="1rem">
                    <LocalizedStrict id="tab-availability-side-start-time-label" attrs={{ label: true }}>
                        <DateTimePicker
                            value={newItem.start}
                            onChange={(newValue) => {
                                if (newValue === null) return
                                setNewItem({ ...newItem, start: newValue })
                            }}
                            viewRenderers={{
                                hours: renderTimeViewClock,
                                minutes: renderTimeViewClock,
                            }}
                            label="Start"
                        />
                    </LocalizedStrict>
                    <LocalizedStrict id="tab-availability-side-end-time-label" attrs={{ label: true }}>
                        <DateTimePicker
                            value={newItem.end}
                            onChange={(newValue) => {
                                if (newValue === null) return
                                setNewItem({ ...newItem, end: newValue })
                            }}
                            viewRenderers={{
                                hours: renderTimeViewClock,
                                minutes: renderTimeViewClock,
                            }}
                            label="End"
                        />
                    </LocalizedStrict>
                </Stack>
                <LocalizedStrict id="tab-availability-modal-reason-label" attrs={{ label: true }}>
                    <TextField
                        label="Reason"
                        value={newItem.reason}
                        onChange={(e) => setNewItem({ ...newItem, reason: e.target.value })}
                    />
                </LocalizedStrict>
                <Stack direction="row" justifyContent="center">
                    <LocalizedStrict id="tab-availability-modal-add-button">
                        <StandardButton
                            fullWidth={false}
                            onClick={() =>
                                onAdd({
                                    start: newItem.start,
                                    end: newItem.end,
                                    reason: newItem.reason,
                                })
                            }
                        >
                            Add
                        </StandardButton>
                    </LocalizedStrict>
                </Stack>
            </Stack>
        </StandardDialog>
    )
}
